export const STATS = {
    // Home page
    all: {
        anchors: 175,
        borrowers: 18525,
        invoices: 422481,
        disbursed: 44505853013.43,
        aum: 3691423000.00,
    },
    // SaralPay Later
    bnpl: {
        anchors: 26 ,
        borrowers: 1848 ,
        invoices: 17881,
        disbursed: 12248614241.05 ,
        aum: 656075000.00 ,
    },
    // Vendor Finance
    vendor: {
        anchors: 12 ,
        borrowers: 90,
        invoices: 812,
        disbursed: 12202863080.40 ,
        aum: 1333415000.00 ,
    },
    // Supplychain finance
    scf: {
        anchors:   28 ,
        borrowers:   28 ,
        invoices: 1517,
        disbursed: 20054375691.98 ,
        aum:   1701933000.00 ,
    },
};
